<template>
  <div id="spa-shop" :data-debugging="debugging" v-if="$store.getters.isIE || loadedUserInfo">
    <div v-if="$store.getters.isAdminMode">
      <span @click="recalculateBoxProps()">Schnellübersicht aktualisieren</span>
      <div v-if="$store.getters.getCurrentLevel === 3">
        Boxgröße: {{ boxSize }}
      </div>
      {{ taxInfo }}
    </div>

    <EmptyLayout v-if="$route.meta.layout === 'Empty'" />
    <NoContainerLayout v-else-if="$route.meta.layout === 'NoContainer'" />
    <ConfiguratorLayout v-else-if="$route.meta.layout === 'Configurator'" />
  </div>
  <TheLoader v-else />
</template>

<script>
import axios from 'axios';
import Bowser from 'bowser';

import TheLoader from '@/components/TheLoader';
import {
  getPriceLevel3,
} from '@/helper/functions.js';
import ConfiguratorLayout from '@/layouts/ConfiguratorLayout';
import EmptyLayout from '@/layouts/EmptyLayout';
import NoContainerLayout from '@/layouts/NoContainerLayout';
import { helperMixin } from '@/mixins/HelperMixin';
import { LoaderMixin } from '@/mixins/LoaderMixin';
import { logicMixin } from '@/mixins/LogicMixin';
import BoxState from '@/model/Box';

export default {
  components: {
    ConfiguratorLayout,
    NoContainerLayout,
    EmptyLayout,
    TheLoader,
  },
  mq: {
    xs: '(max-width: 36em)',
    sm: '(max-width: 48em)',
    md: '(max-width: 64em)',
    lg: '(max-width: 80em)'
  },
  data: function() {
    return {
      debugging: process.env.NODE_ENV === 'development',
      boxSize: '',
      taxInfo: '',
      loadedUserInfo: false,
    };
  },
  mixins: [logicMixin, LoaderMixin, helperMixin],
  created: function () {
    this.$store.commit('setBrowser', Bowser.getParser(window.navigator.userAgent));

    if (this.$route.path.startsWith('/b2c') || this.$route.path.startsWith('/b2b')) {
      const storage = localStorage.getItem('firstVisitWithGroup');
      if (storage === null) {
        if (this.$route.path.startsWith('/b2c')) {
          this.trackEvent('setB2c', { source: 'Direct Link' });
        } else {
          this.trackEvent('setB2b', { source: 'Direct Link' });
        }
        localStorage.setItem('firstVisitWithGroup', true);
      }
    }

    const params = new URLSearchParams(window.location.search);
    if (!this.loadedUserInfo) {
      document.title = 'Geschenkkörbe online bestellen oder selber zusammenstellen - Componata';

      // User group and id
      if ((window.location.href.indexOf('b2b') > -1 && !params.has('switch_group')) || (params.has('switch_group') && params.get('switch_group') === 'b2b')) {
        this.$store.commit('setUserGroupId', '2571');
      } else if (params.has('switch_group') && params.get('switch_group') === 'arag') {
        this.$store.commit('setUserGroupId', '21832');
      } else if (params.has('switch_group') && params.get('switch_group') === 'fleurop') {
        this.$store.commit('setUserGroupId', '22832');
      } else if (params.has('switch_group') && params.get('switch_group') === 'autohero') {
        this.$store.commit('setUserGroupId', '22466');
      } else if (params.has('switch_group') && params.get('switch_group') === 'autohero') {
        this.$store.commit('setUserGroupId', '22466');
      } else if (params.has('switch_group') && params.get('switch_group') === 'dacoso') {
        this.$store.commit('setUserGroupId', '22404');
      } else if (params.has('switch_group') && params.get('switch_group') === 'tecis') {
        this.$store.commit('setUserGroupId', '14017');
      } else if (params.has('switch_group') && params.get('switch_group') === 'tecis_hh') {
        this.$store.commit('setUserGroupId', '16990');
      } else {
        this.$store.commit('setUserGroupId', '62');
      }
      axios
        .get(
          process.env.VUE_APP_BASE_URL +
            '/save_user_id.php?given_group_id=' + this.$store.getters.getUserGroupId
        )
        .then((response) => {
          if (this.$store.getters.getUserGroupId !== 8442 && this.$store.getters.getUserGroupId !== '8442' && this.$store.getters.getUserGroupId !== 21832 && this.$store.getters.getUserGroupId !== '21832' && this.$store.getters.getUserGroupId !== 22832 && this.$store.getters.getUserGroupId !== '22832' && this.$store.getters.getUserGroupId !== 22404 && this.$store.getters.getUserGroupId !== '22404' && this.$store.getters.getUserGroupId !== 22466 && this.$store.getters.getUserGroupId !== '22466' && this.$store.getters.getUserGroupId !== 14017 && this.$store.getters.getUserGroupId !== '14017' && this.$store.getters.getUserGroupId !== 16990 && this.$store.getters.getUserGroupId !== '16990' && this.$store.getters.getUserGroupId !== 44676 && this.$store.getters.getUserGroupId !== '44676' && this.$store.getters.getUserGroupId !== '45573' && this.$store.getters.getUserGroupId !== 45573 && this.$store.getters.getUserGroupId !== 46015 && this.$store.getters.getUserGroupId !== '46015') {
            this.$store.commit('setUserGroupId', response.data.userGroupId);
          }
          this.loadedUserInfo = true;

          if (this.$store.getters.isB2b && this.$route.path.includes('b2c')) {
            this.$router.push(this.$route.path.replace('b2c', 'b2b')).catch(() => {});
          } else if (!this.$store.getters.isB2b && this.$route.path.includes('b2b')) {
            this.$router.push(this.$route.path.replace('b2b', 'b2c')).catch(() => {});
          }

          axios
            .get(
              process.env.VUE_APP_BASE_URL +
                '/wp-json/geschenkbox/v1/get_configurator_specials'
            )
            .then((response) => {
              this.$store.commit('setPricesExtraChars', response.data.extra_char);
              this.$store.commit('setPricesPostcard', response.data.postcard);
              this.$store.commit('setPriceExternalCard', response.data.external_card);
              this.$store.commit('setPostCardExcludedGroups', response.data.postcard_excluded_groups);
              this.$store.commit('setExternalCardExcludedGroups', response.data.external_card_excluded_groups);
              this.$store.commit('setPricesLogoProduct', response.data.logo);
              this.$store.commit('setPricesSchuberProduct', response.data.schuber_branding);
              this.$store.commit('setPricesOwnMotiveProduct', response.data.own_motive);
              this.$store.commit('setPricesSinglePackageProduct', response.data.single_package);
              this.$store.commit('setMsgSettings', response.data.messages);
              const tiers = {};
              tiers.single = {};
              tiers.single.min = 1;
              tiers.single.max = 1;
              Object.keys(response.data.qty_tiers).forEach(key => {
                tiers[key] = {};
                tiers[key].min = Number(response.data.qty_tiers[key]['order_tiers_' + key + '_min']);
                tiers[key].max = Number(response.data.qty_tiers[key]['order_tiers_' + key + '_max']);
              });
              this.$store.commit('setOrderQtySize', tiers);

              const noticeBannerForbiddenUrls = [];

              if (response.data.notice_banner.forbidden_urls.length > 0) {
                response.data.notice_banner.forbidden_urls.forEach(item => {
                  noticeBannerForbiddenUrls.push(item.notice_banner_forbidden_url);
                });
              }

              this.$store.commit('setNoticeBanner', {
                isActive: response.data.notice_banner.is_active,
                message: response.data.notice_banner.message,
                color: response.data.notice_banner.color,
                forbiddenUrls: noticeBannerForbiddenUrls
              });
            });
          this.loadLevel1();
          this.loadLevel3();
          this.loadPostcards();
          this.loadPostcardMessageTemplates();
          this.loadSettings();
          this.setLastQty();
          this.loadFaq();
          axios.get(process.env.VUE_APP_BASE_URL + '/get_arag.php').then(response => {
            this.$store.commit('setArag', response.data);
          });
        });
    }

    if (params.has('__begin')) {
      this.$store.commit('setLevel1FilterSort', {
        name: '__begin',
        value: parseInt(params.get('__begin')),
      });
    } else if (params.has('__hasProduct')) {
      this.$store.commit('setLevel1FilterSort', {
        name: '__hasProduct',
        id: params.get('__hasProduct'),
        manufacturer: params.get('__manufacturer'),
      });
      this.$store.commit('setLevel3FilterSort', {
        name: '__hasProduct',
        id: parseInt(params.get('__hasProduct')),
        manufacturer: params.get('__manufacturer'),
      });
    } else if (params.has('__event')) {
      this.$store.commit('setLevel1FilterSort', {
        name: '__event',
        value: params.get('__event'),
        onlyB2b: false,
      });
      this.$store.commit('setLevel3FilterSort', {
        name: '__event',
        value: params.get('__event'),
        onlyB2b: false,
      });
    } else {
      // this.$store.commit('setLevel1FilterSort', {
      //   name: '__event',
      //   value: 'xmas1,xmas2',
      //   onlyB2b: false,
      //   isB2b: this.$store.getters.isB2b,
      // });
      this.$store.commit('setLevel3FilterSort', {
        name: '__event',
        value: 'xmas1,xmas2',
        onlyB2b: false,
        isB2b: this.$store.getters.isB2b,
      });
    }

    if (params.has('__minprice1')) {
      this.$store.commit('setLevel1FilterMinPrice', parseInt(params.get('__minprice1')));
    }
    if (params.has('__maxprice1')) {
      this.$store.commit('setLevel1FilterMaxPrice', parseInt(params.get('__maxprice1')));
    }
    if (params.has('__b2cprices1')) {
      if (params.get('__b2cprices1') === '1') {
        this.$store.commit('setLevel1FilterUseB2cPrices', true);
      } else {
        this.$store.commit('setLevel1FilterUseB2cPrices', false);
      }
    }
    if (params.has('__minprice3')) {
      this.$store.commit('setLevel3FilterMinPrice', parseInt(params.get('__minprice3')));
    }
    if (params.has('__maxprice3')) {
      this.$store.commit('setLevel3FilterMaxPrice', parseInt(params.get('__maxprice3')));
    }
    if (params.has('__b2cprices3')) {
      if (params.get('__b2cprices3') === '1') {
        this.$store.commit('setLevel3FilterUseB2cPrices', true);
      } else {
        this.$store.commit('setLevel3FilterUseB2cPrices', false);
      }
    }
    if (params.has('__qty') && this.$store.getters.isB2b) {
      const qty = parseInt(params.get('__qty'));
      localStorage.setItem('lastSelectedQty', qty);
      this.$store.commit('setLevel1FilterB2bQty', qty);
      this.$store.commit('setLevel3FilterB2bQty', qty);
    }
    if (params.has('__deltime') && this.$store.getters.isB2b) {
      const deltime = parseInt(params.get('__deltime'));
      this.$store.commit('setLevel1FilterB2bTime', deltime);
      this.$store.commit('setLevel3FilterB2bTime', deltime);
    }
    if (params.has('__adminmode')) {
      this.$store.commit('setAdminMode', true);
      axios
        .get(
          process.env.VUE_APP_API_URL +
            '/productsWarehouse'
        )
        .then((response) => {
          const qtyObj = { Gerichshain: {} };
          response.data.forEach(line => {
            if (!(line.Artikelnnummer in qtyObj.Gerichshain)) {
              qtyObj.Gerichshain[line.Artikelnnummer] = {};
            }
            line['Mindesthaltbarkeitsdatum (MHD)'] = line['Mindesthaltbarkeitsdatum (MHD)'].replace(' 00:00:00', '');
            if (line['Mindesthaltbarkeitsdatum (MHD)'] === '') {
              line['Mindesthaltbarkeitsdatum (MHD)'] = '31.12.2099';
            }
            if (!(line['Mindesthaltbarkeitsdatum (MHD)'] in qtyObj.Gerichshain[line.Artikelnnummer])) {
              qtyObj.Gerichshain[line.Artikelnnummer][line['Mindesthaltbarkeitsdatum (MHD)']] = 0;
            }
            qtyObj.Gerichshain[line.Artikelnnummer][line['Mindesthaltbarkeitsdatum (MHD)']] += parseInt(line.Anzahl.replace('.', '').replace(',', '.'));
          });
          this.$store.commit('setAdminData', qtyObj);
        });
    }

    if (params.has('__modal_qty')) {
      localStorage.setItem('setupModal', true);
      this.$root.$emit('closeSetupModal');
      const qty = parseInt(params.get('__modal_qty'));
      this.$store.commit('setSelectedQty', { qty: qty, store: this.$store });
      this.$store.commit('setLevel1FilterB2bQty', qty);
      this.$store.commit('setLevel3FilterB2bQty', qty);
    }

    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });

    window.addEventListener('touchstart', this.touchStartHandler, {
      passive: true,
    });
    window.addEventListener('touchmove', this.touchMoveHandler, {
      passive: true,
    });

    this.$store.commit('setGlobalLoading', false);
  },
  beforeDestroy: function () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
      window.removeEventListener('touchstart', this.touchStartHandler, {
        passive: true,
      });
      window.removeEventListener('touchmove', this.touchMoveHandler, {
        passive: true,
      });
    }
  },
  methods: {
    recalculateBoxProps: function() {
      if (this.$store.getters.getCurrentLevel === 3) {
        const checker = new BoxState();
        checker.products = this.$store.getters.getSelectedItem.data.products;
        var result = {};

        for (
          var i = this.$store.getters.getBoxItemsLevel3.length - 1;
          i >= 0;
          --i
        ) {
          result = checker.currentStatus(
            this.$store.getters.getBoxItemsLevel3[i]
          );
          if (result.remainingProducts.length === 0) {
            break;
          }
        }
        this.boxSize = result.name;
      }

      const taxes = {};
      this.$store.getters.getSelectedItem.includedProducts().forEach((product) => {
        if (this.$store.getters.isB2b) {
          const price = getPriceLevel3(product, this.$store.getters.getUserGroupId, this.$store.getters.isB2b);
          if (product.tax.toString() in taxes) {
            taxes[product.tax.toString()] += parseFloat((price).toFixed(2));
          } else {
            taxes[product.tax.toString()] = parseFloat((price).toFixed(2));
          }
        } else {
          const price = getPriceLevel3(product, this.$store.getters.getUserGroupId, this.$store.getters.isB2b);
          if (product.tax.toString() in taxes) {
            taxes[product.tax.toString()] += parseFloat(((price / (1 + (product.tax / 100)))).toFixed(2));
          } else {
            taxes[product.tax.toString()] = parseFloat(((price / (1 + (product.tax / 100)))).toFixed(2));
          }
        }
      });

      this.taxInfo = taxes;
    }
  },
  metaInfo: {
    title: 'Maßgeschneiderte Präsente mit handgeschriebener Grußkarte',
    titleTemplate: '%s - Componata'
  }
};
</script>

<style lang="scss">
@import './assets/styles/global';
</style>
